<script setup lang="ts">
import { computed } from 'vue'

import type { ReportColumn } from '../../../models/column.types'
import type { ReportRow } from '../../../models/report.types'

import { useI18n } from '@/shared/i18n'

const { t } = useI18n()

const props = defineProps<{
  row: ReportRow
  column: ReportColumn
}>()

const chips = computed(() => {
  const value = props.row[props.column.field]
  if (!Array.isArray(value)) return []
  return value
    .filter((entry) => entry !== null && entry !== undefined && entry !== '')
    .map((entry) => String(entry))
})
</script>

<template>
  <div class="report-chip-list flex w-full flex-wrap items-center justify-start gap-3xs py-3xs">
    <span
      v-for="(chip, index) in chips"
      :key="`${chip}-${index}`"
      class="report-chip-list__chip inline-flex items-center rounded-full px-2xs py-3xs font-semibold"
    >
      {{ chip }}
    </span>
    <span v-if="!chips.length" class="report-chip-list__empty text-xs">{{
      t('reports.table.cellUnavailable')
    }}</span>
  </div>
</template>

<style scoped>
.report-chip-list__chip {
  border: 1px solid var(--ui-color-border);
  background: var(--ui-color-surface-sunken);
  color: var(--ui-color-fg);
  font-size: 0.6875rem;
}
.report-chip-list__empty {
  color: var(--ui-color-muted);
}
</style>
